// any properties path is overridable; only these segments stay blocked to prevent prototype pollution
export const FORBIDDEN_PATH_SEGMENTS = new Set(['__proto__', 'prototype', 'constructor']);
